// Save File Locally
// Take a file and filename and opens SaveAs prompt
// External
import { saveAs } from "file-saver";

export async function save_file_locally(file, fileName) {
  saveAs(file, fileName);
}
